export default __webpack_public_path__ + "static/media/BlueHands.f5e7c91e098a8fec4fb1de3a8ec767bb.webp";